<template>
	<BModal id="cancel-booking-modal"
		centered
		:no-footer="showPrompt"
		title="Cancel Booking"
		size="md">
		<template v-if="showPrompt">
			<p>
				Are you sure you want to cancel? You can <a href="#" @click="switchToFortnightly">Switch to a Fortnightly</a> clean
			</p>
			<div class="d-flex justify-content-end gap-sm">
				<BButton
					variant="light"
					class="rounded"
					@click="promptDismissed = true">
					No, I want to cancel my Booking
				</BButton>
				<BButton variant="primary" @click="switchToFortnightly">
					Switch to Fortnightly
				</BButton>
			</div>
		</template>
		<template v-else>
			<BForm>
				<BFormGroup label="Reason" :state="getValidationState('reason')"
					:invalid-feedback="getValidationErrors('reason')">
					<BFormSelect class="custom-select" :model-value="reason"
						:options="app_resources.client_cancellation_reasons"
						required @update:model-value="reason = $event">
						<template #first>
							<option :value="null" disabled>
								Please select a reason
							</option>
						</template>
					</BFormSelect>
				</BFormGroup>
				<BFormGroup label="Comments" :state="getValidationState('comments')"
					:invalid-feedback="getValidationErrors('comments')">
					<BFormTextarea :model-value="comments" :rows="3"
						@update:model-value="comments = $event"></BFormTextarea>
				</BFormGroup>
				<BFormGroup label="Rating" :state="getValidationState('rating')"
					:invalid-feedback="getValidationErrors('rating')">
					<BFormRating :model-value="rating"
						class="interactive-rating"
						variant="warning"
						@update:model-value="rating = $event"></BFormRating>
				</BFormGroup>
			</BForm>
		</template>
		<template #footer>
			<div class="d-flex align-items-center justify-content-end gap-sm">
				<BButton variant="white" @click="$bvModal.hide('cancel-booking-modal')">
					Keep Booking
				</BButton>
				<BButton variant="white" class="text-danger"
					:disabled="submitting"
					@click="cancelBooking">
					<BSpinner v-if="submitting" small></BSpinner>
					Cancel Booking
				</BButton>
			</div>
		</template>
	</BModal>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import {mapState} from 'vuex';

	export default {
		props: {
			booking: {
				type: Object,
				required: true,
			}
		},
		emits: ['booking-canceled'],
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				reason: null,
				comments: null,
				rating: null,
				promptDismissed: false,
				submitting: false,
			}
		},
		computed: {
			...mapState('resources', {
				app_resources: state => state.app_resources,
			}),
			showPrompt() {
				return this.booking.frequency === 'Weekly' && !this.promptDismissed;
			}
		},
		created() {
			if (this.app_resources.client_cancellation_reasons.length === 0) {
				this.$store.dispatch('resources/fetchAppResources');
			}
		},
		methods: {
			async cancelBooking() {
				this.submitting = true;

				await this.$axios.post(`/api/client/bookings/${this.booking.unique_id}/cancel`, {
					reason: this.reason,
					comments: this.comments,
					rating: this.rating,
				}).then(() => {
					this.$bvToast.toast('We have received your cancellation request. Our team will be in touch to confirm it.', {
						title: 'Cancellation Requested',
						variant: 'success',
						solid: true,
					});
					this.$bvModal.hide('cancel-booking-modal');
					this.$emit('booking-canceled');
					this.clearErrors();
				}).catch(error => {
					this.handleError(error);
				})

				this.submitting = false;
			},
			async switchToFortnightly() {
				this.submitting = true;

				await this.$axios.post(`/api/client/bookings/${this.booking.unique_id}/update-frequency`, {
					frequency: 'Fortnightly'
				}).then(() => {
					this.$bvToast.toast('Your booking has been switched to a fortnightly clean.', {
						title: 'Booking Updated',
						variant: 'success',
						solid: true,
					});
					this.$bvModal.hide('cancel-booking-modal');
					this.clearErrors();
				}).catch(error => {
					this.handleError(error);
				})

				this.submitting = false;
			}
		}
	}
</script>
